module.exports = __webpack_public_path__ + "img/platform-6.9787a6a8.png";